import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CloseDialog } from 'src/app/general/services/dialog.service';
import { ScheduleReusedWarningDialogData } from '../util/interfaces';
import { ScheduleReusedWarningDialogComponent } from './schedule-reused-warning-dialog.component';

// ----------------------------------------------------------------------------
// Usage Example

// Template:

// TS:

// public showWarning(): void {
//   const inputDialogData: ScheduleReusedWarningDialogData = {
//     ...
//   }
//   this.ScheduleReusedWarningDialogData.openDialog(inputDialogData);
// }

// ----------------------------------------------------------------------------

@Injectable({
  providedIn: 'root',
})
export class ScheduleReusedWarningDialogService {

  constructor(private dialog: MatDialog) { }

  public openDialog(inputDialogData: ScheduleReusedWarningDialogData) : CloseDialog {
    const dialogRef = this.dialog.open(ScheduleReusedWarningDialogComponent, {
      data: inputDialogData,
      autoFocus: true,
      hasBackdrop: true,
      disableClose: false,
    });

    return () => dialogRef.close();
  }
}
